import {Input, InputNumber, Form} from "antd";

export const InputFilter = ({name = 'input', inputType = 'input', ...rest}) => {
    return (
        <>
            <Form.Item
                name={name}
                noStyle
            >
                {(inputType === 'number')
                    ? (
                        <InputNumber
                            placeholder="input text"
                            style={{
                                width: 200,
                            }}
                            {...rest}
                        />
                    )
                    : (
                        <Input
                            placeholder="input text"
                            style={{
                                width: 200,
                            }}
                            {...rest}
                        />
                    )
                }
            </Form.Item>
        </>
    );
}